import { Container, Row } from "react-bootstrap";

export default function PostSurvey({ qualtricsCompleted, onChange }) {
    return (
        <Container className="study-item">
            <Row>
                <h1 className="subtitle">Complete Post Survey Qualtrics Survey</h1>
                <br />
                <p>Please complete the post survey below</p>
                <Row>
                    <iframe src="https://gatech.co1.qualtrics.com/jfe/form/SV_9N6a9GgJ9MQ2Qf4" allow-scripts="true" className='survey-iframe' />
                </Row>
                <Row>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            checked={qualtricsCompleted}
                            onChange={onChange}
                        />
                        <label className="form-check-label">
                            <span className='mandatory-asterisk'>*</span>
                            I certify that I have completed the qualtrics post-survey.
                        </label>
                    </div>
                </Row>
            </Row>
        </Container>
    );
};
